function doseCalc() {
	
	return {
		
		tab: 'prophy',
		
		age: '',
		weight: '',
		weightUnit: 'lb',
		weightUnitOpen: false,
		currentX: '',
		targetX: '',
		
		showChildDose: false,
		showAdultDose: false,
		
		childProphylacticDose: 0,
		adultProphylacticDose: 0,
		
		childPRNDose: 0,
		adultPRNDose: 0,
		
		childPeriopDose: 0,
		adultPeriopDose: 0,
		
		reset: function() {
			this.age = '';
			this.weight = '';
			this.weightUnit = 'lb';
			this.currentX = '';
			this.targetX = '';
			this.showChildDose = false;
			this.showAdultDose = false;
			this.childProphylacticDose = 0;
			this.adultProphylacticDose = 0;
			this.childPRNDose = 0;
			this.adultPRNDose = 0;
			this.childPeriopDose = 0;
			this.adultPeriopDose = 0;
		},
		
		changeTab: function(t) {
			this.reset();
			this.tab = t;
		},
		
		getWeight: function() {
			var weightKg = parseFloat(this.weight);
			if (this.weightUnit === 'lb') {
				weightKg = weightKg * 0.453592;
			}
			return weightKg;
		},
		
		calcProphy: function() {
			this.showChildDose = false;
			this.showAdultDose = false;
			
			var a = parseInt(this.age, 10);
			var w = this.getWeight();
			if (a >= 12 && w > 0) {
				this.adultProphylacticDose = (w * 25).toLocaleString('en-US', {maximumFractionDigits: 0});
				this.showAdultDose = true;
			} else if (a > 0 && w > 0) {
				this.childProphylacticDose = (w * 40).toLocaleString('en-US', {maximumFractionDigits: 0});
				this.showChildDose = true;
			} 
		},
		
		calcPRN: function() {
			this.showChildDose = false;
			this.showAdultDose = false;
			
			var a = parseInt(this.age, 10);
			var w = this.getWeight();
			if (a >= 12 && w > 0) {
				this.adultPRNDose = (w * 25).toLocaleString('en-US', {maximumFractionDigits: 0});
				this.showAdultDose = true;
			} else if (a > 0 && w > 0) {
				this.childPRNDose = (w * 30).toLocaleString('en-US', {maximumFractionDigits: 0});
				this.showChildDose = true;
			} 
		},
		
		calcPeriop: function() {
			this.showChildDose = false;
			this.showAdultDose = false;
			
			var a = parseInt(this.age, 10);
			var w = this.getWeight();
			var c = parseFloat(this.currentX);
			var t = parseFloat(this.targetX);
			var diff = t - c;
			if (diff > 0) {
				if (a >= 12 && w > 0) {
					this.adultPeriopDose = (w * diff * 0.5).toLocaleString('en-US', {maximumFractionDigits: 0});
					this.showAdultDose = true;
				} else if (a > 0 && w > 0) {
					this.childPeriopDose = (w * diff * 0.6).toLocaleString('en-US', {maximumFractionDigits: 0});
					this.showChildDose = true;
				} 
			} 
			
		}
	}
}
